module.exports = __webpack_public_path__ + "img/ic-close.ef51b9e0.svg";